import req from "../http";

const notice = {
  // 發送 錄取通知
  noticeOfHire(params) {
    return req("post", "/Notice/Hire", params);
  },

  // 發送 報到通知
  noticeOfReport(params) {
    return req("post", "/Notice/Report", params);
  },

  // 依據 MatchId 取得錄取通知信內容
  getNoticeOfHiringMail(matchId) {
    return req("get", `/Notice/GetHireNoticeMail/${matchId}`);
  },

  // 依據 MatchId 取得報到通知信內容
  getNoticeOfReportMail(matchId) {
    return req("get", `/Notice/GetReportNoticeMail/${matchId}`);
  },

  // 依據 MatchId 取得感謝函內容
  getThankYouMail(matchId) {
    return req("get", `/Notice/GetThanksNoticeMail/${matchId}`);
  },
};

export default notice;
